export const route = 'driver';

export const LIST_SET_PARAMS = 'LIST_SET_PARAMS';
export const LIST_FETCH_REQUEST = 'LIST_FETCH_REQUEST';
export const LIST_FETCH_SUCCESS = 'LIST_FETCH_SUCCESS';
export const LIST_FETCH_FAILURE = 'LIST_FETCH_FAILURE';

export const CREATE_FETCH_REQUEST = 'CREATE_FETCH_REQUEST';
export const CREATE_FETCH_SUCCESS = 'CREATE_FETCH_SUCCESS';
export const CREATE_FETCH_FAILURE = 'CREATE_FETCH_FAILURE';

export const STATE_CHANGE_FETCH_REQUEST = 'STATE_CHANGE_FETCH_REQUEST';
export const STATE_CHANGE_FETCH_SUCCESS = 'STATE_CHANGE_FETCH_SUCCESS';
export const STATE_CHANGE_FETCH_FAILURE = 'STATE_CHANGE_FETCH_FAILURE';